import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

@Component({
  selector: 'ts-footer-bar',
  templateUrl: './footer-bar.component.html',
  imports: [TranslationPipe]
})
export class FooterBarComponent {
  @Input() company_name: string = '';
  year: number = new Date().getFullYear();

  constructor(public sanitizer: DomSanitizer) {}
}
